import { type Site, type Point, type IFeatureReport } from "@/lib/models"
import { axiosWithAuth } from "@/lib/AxiosClient";
import { DownloadService } from "@/services/DownloadService";

export interface MapData {
  id: string
  name: string
  description: string | null
  zoom: number
  latitude: number,
  longitude: number,
  modifiedAt: string
  thumbnail?: string
  ownerId: string
  tenantId: string
  tenantName: string
}

export interface SiteSummary {
  name: string
  description: string | null
}

export interface CreateMapRequest {
  name: string
  description?: string
  tenantId: string
  latitude: number
  longitude: number
  zoom: number
}

export interface UpdateMapRequest {
  name: string
  description?: string | null
  point: Point
  zoom: number
}

export interface AttachmentDetails {
  id: string
  filename: string
  url: string
  size: number
}

export class SiteService {
  private static readonly BASE_PATH = "/api/sites"
  private static instance = axiosWithAuth;

  static async getUserMaps(): Promise<MapData[]> {
    const response = await this.instance.get<MapData[]>(this.BASE_PATH);
    return response.data;
  }

  static async getSiteById(siteId: string): Promise<Site> {
    const response = await this.instance.get<Site>(`${this.BASE_PATH}/${siteId}`);
    return response.data;    
  }

  static async createMap(data: CreateMapRequest): Promise<MapData> {
    const response = await this.instance.post<MapData>(this.BASE_PATH, data)
    return response.data;
  }

  static async updateSiteSummary(mapId: string, data: SiteSummary): Promise<void> {
    const response = await this.instance.patch<void>(`${this.BASE_PATH}/${mapId}`, data)
    return response.data;
  }

  static async deleteMap(mapId: string): Promise<void> {
    const response = await this.instance.delete<void>(`${this.BASE_PATH}/${mapId}`)
    return response.data;
  }

  static async createFeatureReport(siteId: string, report: IFeatureReport): Promise<void> {
    await DownloadService.download(`${this.BASE_PATH}/${siteId}/report/feature`, {
      method: 'POST',
      data: report,
    }, 'monthly-report.xlsx');
  }
}
